import React from 'react'
import { Badge } from '@mui/material'
import { BadgeOnNotificationProps } from './_props'
import useStyles from './_styles'

export const BadgeOnNotification: React.FC<BadgeOnNotificationProps> = ({ label, displayBadge, children }) => {
    const classes = useStyles()
    return (
        <span>
            <Badge
                variant="dot"
                invisible={!displayBadge}
                classes={{
                    badge: classes.badgeNotification,
                }}
            >
                {children}
            </Badge>
        </span>
    )
}
